/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFEnumerationEvent } from './CRSFEnumerationEvent';
import {
    CRSFEnumerationEventFromJSON,
    CRSFEnumerationEventFromJSONTyped,
    CRSFEnumerationEventToJSON,
} from './CRSFEnumerationEvent';
import type { CRSFEnumerationStats } from './CRSFEnumerationStats';
import {
    CRSFEnumerationStatsFromJSON,
    CRSFEnumerationStatsFromJSONTyped,
    CRSFEnumerationStatsToJSON,
} from './CRSFEnumerationStats';
import type { CRSFIPDetails } from './CRSFIPDetails';
import {
    CRSFIPDetailsFromJSON,
    CRSFIPDetailsFromJSONTyped,
    CRSFIPDetailsToJSON,
} from './CRSFIPDetails';

/**
 * 
 * @export
 * @interface CRSFAggregatedEnumerationResult
 */
export interface CRSFAggregatedEnumerationResult {
    /**
     * 
     * @type {Array<CRSFEnumerationEvent>}
     * @memberof CRSFAggregatedEnumerationResult
     */
    events: Array<CRSFEnumerationEvent>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFAggregatedEnumerationResult
     */
    extra: Array<string>;
    /**
     * 
     * @type {{ [key: string]: CRSFIPDetails; }}
     * @memberof CRSFAggregatedEnumerationResult
     */
    ip_details?: { [key: string]: CRSFIPDetails; };
    /**
     * 
     * @type {string}
     * @memberof CRSFAggregatedEnumerationResult
     */
    query: string;
    /**
     * 
     * @type {CRSFEnumerationStats}
     * @memberof CRSFAggregatedEnumerationResult
     */
    stats: CRSFEnumerationStats;
    /**
     * 
     * @type {number}
     * @memberof CRSFAggregatedEnumerationResult
     */
    total: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFAggregatedEnumerationResult
     */
    wildcards?: Array<string>;
}

/**
 * Check if a given object implements the CRSFAggregatedEnumerationResult interface.
 */
export function instanceOfCRSFAggregatedEnumerationResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "events" in value;
    isInstance = isInstance && "extra" in value;
    isInstance = isInstance && "query" in value;
    isInstance = isInstance && "stats" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFAggregatedEnumerationResultFromJSON(json: any): CRSFAggregatedEnumerationResult {
    return CRSFAggregatedEnumerationResultFromJSONTyped(json, false);
}

export function CRSFAggregatedEnumerationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFAggregatedEnumerationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(CRSFEnumerationEventFromJSON)),
        'extra': json['extra'],
        'ip_details': !exists(json, 'ip_details') ? undefined : (mapValues(json['ip_details'], CRSFIPDetailsFromJSON)),
        'query': json['query'],
        'stats': CRSFEnumerationStatsFromJSON(json['stats']),
        'total': json['total'],
        'wildcards': !exists(json, 'wildcards') ? undefined : json['wildcards'],
    };
}

export function CRSFAggregatedEnumerationResultToJSON(value?: CRSFAggregatedEnumerationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'events': ((value.events as Array<any>).map(CRSFEnumerationEventToJSON)),
        'extra': value.extra,
        'ip_details': value.ip_details === undefined ? undefined : (mapValues(value.ip_details, CRSFIPDetailsToJSON)),
        'query': value.query,
        'stats': CRSFEnumerationStatsToJSON(value.stats),
        'total': value.total,
        'wildcards': value.wildcards,
    };
}

